import(/* webpackMode: "eager" */ "/codebuild/output/src695705932/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/error.tsx");
